<div [ngStyle]="getMyStyles()" class="skelt-load loader"></div>
